<template lang="pug">
  div
    sidebar
      ul.group-list
        li.list-complete-item
          router-link.group-link(:to="{name: 'mdm-profiles'}")
            span {{$t('mdm_page.device_policy')}}
        li.list-complete-item.li-head
          icon(name="caret-down")
          span {{$t('mdm_page.app_management')}}
          ul
            //- v1 게이트: Android 외 OS는 미노출. 되살리려면 아래 두 블록 주석 해제
            //- li.list-complete-item
            //-   router-link.group-link(:to="{name: 'mdm-apps', params: {platform: 'windows'}}")
            //-     span Windows
            li.list-complete-item
              router-link.group-link(:to="{name: 'mdm-apps', params: {platform: 'android'}}")
                span Android
            //- li.list-complete-item
            //-   router-link.group-link(:to="{name: 'mdm-apps', params: {platform: 'osx'}}")
            //-     span macOS
    div.lmm-content-body
      router-view
</template>

<script>
// MDM 도메인 레이아웃 — 좌측 사이드바 + 본문 router-view (management 화면 패턴)
import Sidebar from "../mixins/sidebar"

export default {
  name: "MdmLayout",
  components: { sidebar: Sidebar },
}
</script>
